import { render, staticRenderFns } from "./FiscalDataTab.vue?vue&type=template&id=0b4687dc&scoped=true"
import script from "./FiscalDataTab.vue?vue&type=script&lang=js"
export * from "./FiscalDataTab.vue?vue&type=script&lang=js"
import style0 from "./FiscalDataTab.vue?vue&type=style&index=0&id=0b4687dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4687dc",
  null
  
)

export default component.exports